import { useTranslation } from 'react-i18next';

import PageTitle from '../../shared/PageTitle/PageTitle';
import Reviews from '../../components/ui/ReviewsPage/Reviews';

import styles from './styles.module.scss';

const CustomerReviewsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.customerReviewsPage}>
      <div className={styles.conatiner}>
        <PageTitle align='center'>{t("reviews")}</PageTitle>
        <Reviews />  
      </div>
    </div>
  )
}

export default CustomerReviewsPage